function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 31.833c6.535 0 11.833-5.298 11.833-11.833S26.535 8.167 20 8.167 8.167 13.465 8.167 20 13.465 31.833 20 31.833zm0 1.5c-7.364 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.333 13.333-13.333 7.364 0 13.333 5.97 13.333 13.333 0 7.364-5.97 13.333-13.333 13.333zM18.213 15.06l6.848 3.978a1.5 1.5 0 010 2.594l-6.848 3.978a1.5 1.5 0 01-2.254-1.297v-7.956a1.5 1.5 0 012.254-1.297z",
  fillRule: "nonzero",
  fill: "#000"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
};

export default SvgComponent;